<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
      width="300px"
    >
      <Navigation />
    </v-navigation-drawer>

    <v-app-bar
      ref="app_bar"
      color="primary"
      app
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <template v-if="logo_name() === 'the-reading'">
          <router-link to="/">
          <v-img
            height="52"
            width="249"
            src="./assets/the-reading.png"
          ></v-img>
          </router-link>
        </template>
        <template v-else>
          <router-link to="/">
          <v-img
            height="52"
            width="186"
            src="./assets/t-3mt.png"
          ></v-img>
          </router-link>
        </template>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <Account
        ref="account"
        v-on:login="on_login"
        v-on:logout="on_logout"
      >
      </Account>
      <template v-if="!$store.getters.preference
        || !('notify_success' in $store.getters.preference)
        || ($store.getters.preference.notify_success === true)">
        <WebSocket />
      </template>
      <Notification />
      <LangSelector
        ref="lang_selector"
      >
      </LangSelector>
      <template v-if="$store.getters.user !== null">
        <AppMenu />
      </template>
    </v-app-bar>

    <v-main>
      <template v-if="$route.path.startsWith('/editor')">
        <router-view
          :key="$route.fullPath"
        ></router-view>
      </template>
      <template v-else>
        <v-container fluid>
          <router-view
            :key="$route.fullPath"
          ></router-view>
        </v-container>
      </template>
      <template v-if="$store.getters.debug_source_ip">
        <v-chip
          class="float-right mt-5 mr-5"
        >
          <v-text-field
            label="source_ip"
            v-model="source_ip"
          >
          </v-text-field>
          <v-btn
            color="primary"
            @click="save_source_ip()"
          >
            {{ $t("message.common.regist") }}
          </v-btn>
        </v-chip>
      </template>
    </v-main>
    <SupportWidget />

    <v-footer
      ref="footer"
      class="footer"
      color="primary"
      fixed
      app
      dark
    >
      <v-spacer></v-spacer>
      <span>&copy; {{ get_copyright_year }} Rozetta Corp.</span>
    </v-footer>

    <Snackbar></Snackbar>
    <Confirm
      ref="unsave_confirm"
      :message="$t('message.common.unsave_confirm')"
      :positive="$t('message.common.yes')"
      :negative="$t('message.common.no')"
    >
    </Confirm>
    <Confirm
      ref="editing_confirm"
      :positive="$t('message.common.yes')"
      :negative="$t('message.common.no')"
    >
    </Confirm>
  </v-app>
</template>

<script>
import Navigation from './components/Navigation'
import Account from './components/Account'
import WebSocket from './components/WebSocket'
import Notification from './components/Notification'
import LangSelector from './components/LangSelector'
import Snackbar from './components/Snackbar'
import SupportWidget from './components/SupportWidget'
import Confirm from './components/Confirm'
import AppMenu from './components/AppMenu'
import { get_fields } from "./js/get_fields";
import { http_error } from "./js/http_error";
import { mapGetters } from 'vuex';
import { web_socket } from "./js/web_socket";
import { editor } from "./js/editor";
import { menu_items } from "./js/editor_menu_items";
import localforage from "localforage";

export default {
  name: 'App',
  components: {
    Navigation,
    Account,
    WebSocket,
    Notification,
    LangSelector,
    Snackbar,
    SupportWidget,
    Confirm,
    AppMenu
  },
  mixins: [get_fields, http_error, web_socket, editor],
  data () {
    this.get_idps();
    return {
      module_id: "01",
      source_ip: ""
    }
  },
  mounted: function(){
    // resize
    this.on_resize();
    window.addEventListener('resize', this.on_resize);
    // ドメイン判定
    if(this.logo_name() === "the-reading"){
      document.getElementById("top_title").innerText = "The Reading"
    }else{
      document.getElementById("top_title").innerText = "T-3MT"
    }
    this.$store.commit("setDomain", this.logo_name());
    // IdP連携iid取得
    this.get_rozetta_iid();
    // 言語ペア・分野キャッシュ
    this.get_lang_pair();
    // version不一致警告
    if(window.location.host !== "localhost:8080"){
      // 開発モード(localhost:8080)は対象外
      this.$http.get(window.location.protocol + "//" + window.location.host + "/api/endpoint")
        .then(response => {
          if("data" in response){
            if(this.$store.getters.debug){
              console.log("response.data:" + JSON.stringify(response.data));
            }
            if(response.data.endpoint.split("/")[3] !== ("v" + this.$store.getters.api_version)){
              var url = response.data.endpoint.replace("api", "");
              this.$store.commit("setNotification", {
                type: "warning",
                message: {
                  eid: "E101111",
                  param: {
                    url: url
                  }
                },
                route: url
              });
            }
          }
        })
        .catch( error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    }
    // デフォルトショートカット設定
    this.$store.commit("editor/setShortcut", menu_items.methods.default_shortcut());
    // preferenceの読み込み
    var preference = null;
    try{
      preference = JSON.parse(localStorage.getItem(this.$store.getters.domain + '_preference'));
    }catch(e){
      // エラールート
      if(this.$store.getters.debug){
        console.error("getItem preference:" + e);
      }
      this.$store.commit("setNotification", {
        type: "warning",
        message: {
          eid: "E1" + this.module_id + "106" + ":00000001",
          param: {}
        }
      });
    }
    if(preference !== null
      && ("format" in preference)
      && preference.format.type === "preference"){
      // v2
      // 今のところは互換性の考慮は不要
      this.$store.commit("setPreference", preference.preference);
      if(this.$store.getters.preference){
        var preference = this.$store.getters.preference;
        if(preference.editor){
          /*if(preference.editor.content_mode){
            this.$store.commit("editor/setContentMode", preference.editor.content_mode);
          }*/
          if(preference.editor.enable_backup){
            this.$store.commit("editor/setEnableBackup", preference.editor.enable_backup);
          }
          if(preference.editor.history_limit){
            this.$store.commit("editor/setHistoryLimit", preference.editor.history_limit);
          }
          if(preference.editor.case_sensitive){
            this.$store.commit("editor/setSearchCaseSensitive", preference.editor.case_sensitive);
          }
          if(preference.editor.font_size){
            this.$store.commit("editor/setFontSize", preference.editor.font_size);
          }
          if(preference.editor.layout_mode){
            this.$store.commit("editor/setLayoutMode", preference.editor.layout_mode);
          }
          if(preference.editor.menu_mode){
            this.$store.commit("editor/setMenuMode", preference.editor.menu_mode);
          }
          if(preference.editor.sentence_mode){
            this.$store.commit("editor/setSentenceMode", preference.editor.sentence_mode);
          }
          if("memo_mode" in preference.editor){
            this.$store.commit("editor/setMemoMode", preference.editor.memo_mode);
          }
          if(preference.editor.shortcut){
            this.$store.commit("editor/setShortcut", preference.editor.shortcut);
          }
        }
        if(preference.lang_select
          && preference.lang_select !== "auto"
          && this.$refs.lang_selector){
          this.$refs.lang_selector.selectLang(this.$store.getters.preference.lang_select);
        }
      }
    }else{
      // v1: 旧フォーマット(メタデータなし)
      this.$store.commit("setPreference", preference);
    }
  },
  beforeDestroy() {
    document.removeEventListener('resize', this.on_resize)
  },
  methods: {
    get_idps: function() {
      this.$http.get(this.$store.getters.api_endpoint + "/idp_list")
        .then( response => {
          if(response && "data" in response){
            if(this.$store.getters.debug){
              console.log("response.data:" + JSON.stringify(response.data));
            }
            var idps = {};
            for(var idp of response.data){
              idps[idp.iid] = idp;
            }
            this.$store.commit("setIdps", idps);
          }
        })
        .catch( error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    logo_name: function(){
      var domain = location.hostname.split(".");
      if(domain[0].endsWith("t-3mt")
        || domain[0].startsWith("localhost")){
        return "t-3mt";
      }else{
        return "the-reading";
      }
    },
    get_rozetta_iid: function(){
      this.$http.get(this.$store.getters.api_endpoint + "/user/rozetta_user/idp")
        .then( response => {
          if(response && "data" in response){
            if(this.$store.getters.debug){
              console.log("response.data:" + JSON.stringify(response.data));
            }
            this.$store.commit("setRozettaIdp", response.data.iid);
          }
        })
        .catch( error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    save_source_ip: function(){
      if(this.source_ip !== ""){
        localStorage.setItem('source_ip', this.source_ip);
      }else{
        localStorage.removeItem('source_ip');
      }
    },
    on_login: function(user){
      // enable_options
      this.$router.onReady(() => {
        var enable_options = [];
        for(var option of ['develop', 'in-company']){
          if(option in this.$route.query
            && Array.isArray(user.allowed_options)
            && user.allowed_options.indexOf(option) >= 0){
            enable_options.push(option);
          }
        }
        this.$store.commit("setEnableOptions", enable_options);
      });
      if(this.$store.getters.preference
        && this.$store.getters.preference.web_socket){
        // WebSocket自動接続
        this.connect();
      }
      localforage.config({
        name: this.logo_name(),
        storeName: "editor"
      });
      localforage.ready()
      .then(async () => {
        var backup = {};
        var backup_keys = [
          "user",
          "utime",
        ].concat(this.$store.getters["editor/backup_keys"]);
        try{
          for(var backup_key of backup_keys){
            backup[backup_key] = await localforage.getItem(backup_key);
            if(backup[backup_key] === null){
              localforage.clear();
              // .catchはtry節の方へ飛んでいく
              this.$router.onReady(() => {
                if(this.$route.query.redirect){
                  this.$router.replace(this.$route.query.redirect);
                }
              });
              return;
            }
          }
        }catch(e){
          // エラールート
          if(this.$store.getters.debug){
            console.error("localforage.getItem:" + e);
          }
          this.$store.commit("setNotification", {
            type: "warning",
            message: {
              eid: "E191113:00000001",
              param: {}
            }
          });
          this.$router.onReady(() => {
            if(this.$route.query.redirect){
              this.$router.replace(this.$route.query.redirect);
            }
          });
          return;
        }
        if(backup.tabs.length > 0
          && backup.user !== null
          && backup.user.uid === user.uid){
          this.$refs.editing_confirm.open(this.$i18n.t("message.common.editing_confirm", {
            xid: backup.tabs[0].id,
            name: backup.tabs[0].name,
            utime: this.$i18n.d(1000 * backup.utime, 'long', this.$store.getters.langs[this.$i18n.locale].locale)
          }), 600)
            .then((result) => {
              if(result){
                this.$store.commit("editor/setEditor", backup);
                this.$router.onReady(() => {
                  this.$router.replace("/editor/" + backup.tabs[0].mode + "/" + backup.tabs[0].id);
                  this.$store.commit("editor/setSelectTab", backup.tabs[0].id);
                });
              }else{
                this.$router.onReady(() => {
                  if(this.$route.query.redirect){
                    this.$router.replace(this.$route.query.redirect);
                  }
                });
                localforage.clear();
                // .catchは一段上の方へ飛んでいく
              }
            })
            .catch((e) => {
              if(this.$store.getters.debug){
                console.error("localforage.dropInstance:" + e);
              }
              this.$store.commit("setNotification", {
                type: "warning",
                message: {
                  eid: "E191113:00000003",
                  param: {}
                }
              });
              this.$router.onReady(() => {
                if(this.$route.query.redirect){
                  this.$router.replace(this.$route.query.redirect);
                }
              });
            });
        }
      })
      .catch((e) => {
        if(this.$store.getters.debug){
          console.error("localforage.ready", e);
        }
        this.$store.commit("setNotification", {
          type: "warning",
          message: {
            eid: "E191113:00000004",
            param: {}
          }
        });
        this.$router.onReady(() => {
          if(this.$route.query.redirect){
            this.$router.replace(this.$route.query.redirect);
          }
        });
      });
    },
    on_logout: function(){
      var modified_tabs = [];
      if(this.$route.path.startsWith("/editor")){
        for(var tab of this.$store.getters["editor/tabs"]){
          if(this.$store.getters["editor/" + tab.id + "/content_modified"]){
            modified_tabs.push(tab);
          }
        }
      }
      if(this.$route.path.startsWith("/editor")
        && modified_tabs.length > 0
        && this.$refs.unsave_confirm){
        this.$refs.unsave_confirm.open()
          .then( result => {
            if(result
              && this.$refs.account){
              this.reset_editor();
              // WebSocketの切断
              this.disconnect();
              this.$refs.account.logout();
            }
          });
      }else if(this.$refs.account){
        // WebSocketの切断
        this.disconnect();
        this.$refs.account.logout();
      }
    },
    on_resize: function(){
      var main_height = window.innerHeight;
      if(this.$refs.app_bar && this.$refs.app_bar.$el && this.$refs.app_bar.$el.clientHeight){
        main_height -= this.$refs.app_bar.$el.clientHeight;
      }
      if(this.$refs.footer && this.$refs.footer.$el && this.$refs.footer.$el.clientHeight){
        main_height -= this.$refs.footer.$el.clientHeight;
      }
      this.$store.commit("setMainHeight", main_height);
    }
  },
  computed: {
    get_copyright_year: function(){
      var date = new Date();
      if(date.getFullYear() === 2020){
        return "2020"
      }else{
        return "2020-" + date.getFullYear()
      }
    },
    drawer: {
      get () {
        return this.$store.state.side_menu;
      },
      set (value) {
        this.$store.commit('setSideMenu', value)
      }
    }
  },
}
</script>

<style>
* { text-transform: none !important; }
.footer {
  font-size: 14px;
}
@media screen and (max-width: 550px) {
  .v-footer {
    position: absolute !important;
  }
}
div.v-window.v-item-group.theme--light.v-tabs-items {
  overflow: visible;
}
</style>
